<template>
  <router-view v-if="isrouterview" />
</template>

<script>
import createStore from "./store/index";
export default {
  data() {
    return {
      isrouterview: true,
    };
  },
  computed: {
    count() {
      return createStore.state.lange;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },
  },
  watch: {
    count() {
      this.isrouterview = false;
      this.$nextTick(function () {
        this.isrouterview = true;
      });
    },
  },
};
</script>

<style>
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";
@import "./assets/css/iconfont/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/App.vue